@if (show_admin_vacation_management()) {
  <div class="row mb-4">
    <div class="col-12">
      <div class="page-title d-flex flex-wrap align-items-center gap-3">
        <h2 class="mb-0">Gestionar vacaciones de trabajador</h2>
        <mat-form-field appearance="outline" class="nobottom">
          <mat-label>Trabajador</mat-label>
          <mat-select [(ngModel)]="selectedWorkerId" (ngModelChange)="onWorkerOrYearChange()">
            @for (worker of workers(); track worker.id) {
              <mat-option [value]="worker.id">{{ worker.name }} {{ worker.surnames }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="nobottom">
          <mat-label>Año</mat-label>
          <mat-select [(ngModel)]="selectedYear" (ngModelChange)="onWorkerOrYearChange()">
            @for (year of years; track year) {
              <mat-option [value]="year">{{ year }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button mat-flat-button color="accent" (click)="openCreateVacationsDialog()" [disabled]="selectedWorkerId == null">
          Solicitar vacaciones
        </button>
        @if (workerSpentDays != null) {
          <span class="text-muted">Adjudicadas: {{ workerSpentDays | number: '1.0-0' }} días</span>
        }
      </div>

      <div class="bisual-table mt-3">
        <div class="bisual-table-container">
          <table mat-table [dataSource]="workerVacationsDataSource">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Fecha</th>
              <td mat-cell *matCellDef="let item">{{ item.from_date | date: 'shortDate' }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let item">
                @if (isVacationCompleted(item)) {
                  <span class="done">Completado</span>
                } @else {
                  <span class="accepted">Aceptado</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="year_imputed">
              <th mat-header-cell *matHeaderCellDef>Imputado en el año</th>
              <td mat-cell *matCellDef="let item">{{ item.year }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let item">
                <button mat-icon-button color="warn" (click)="deleteVacation(item)" matTooltip="Eliminar vacación">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="workerVacationsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: workerVacationsColumns"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
}

<div class="row text-center">
  <div class="col-md-4">
    <div class="btn-group">
      <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
        Anterior
      </div>
      <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">Hoy</div>
      <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
        Siguiente
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h3>{{ viewDate | calendarDate: view + 'ViewTitle' : 'es' }}</h3>
  </div>
</div>

<mwl-calendar-month-view
  [viewDate]="viewDate"
  [events]="events"
  [locale]="locale"
  [weekStartsOn]="weekStartsOn"
  [weekendDays]="weekendDays"
  [refresh]="refresh"
  [cellTemplate]="customMonthCell"
>
</mwl-calendar-month-view>

<ng-template #customMonthCell let-day="day">
  <div
    class="cal-day-cell"
    [ngClass]="{
      'cal-out-month': !day.inMonth,
      'cal-in-month': day.inMonth,
      'cal-weekend': day.isWeekend,
    }"
  >
    <div class="cal-day-number">
      {{ day.date | date: 'd' }}
    </div>

    <div class="custom-event row">
      @for (event of day.events; track event) {
        <div class="col">
          @if (event.meta.type === 'holiday') {
            <span class="event" [matTooltip]="event.title">🎉</span>
          } @else if (event.meta.type === 'vacation') {
            @if (event.meta.imageUrl) {
              <img [src]="event.meta.imageUrl" alt="Event image" class="event" [matTooltip]="event.title" />
            }
          } @else if (event.meta.type === 'absence') {
            <span class="event" [matTooltip]="event.title">🪑</span>
          } @else if (event.meta.type === 'birthday') {
            <span class="event" [matTooltip]="event.title">🎁</span>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
